// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3877": "fd6608f1","705": "a5379b51","7594": "c8585f9c","8584": "16ee0354",}[chunkId] + ".css"
}